import logo from "./logo.svg";
import "./App.css";
import Body from "./components/Body";

function App() {
  return (
    <div className="flex flex-col min-h-screen">
      <Body />
    </div>
  );
}

export default App;
